import { render, staticRenderFns } from "./ColumnChartGridWidget.vue?vue&type=template&id=36eb4d7e&scoped=true&"
import script from "./ColumnChartGridWidget.vue?vue&type=script&lang=ts&"
export * from "./ColumnChartGridWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnChartGridWidget.vue?vue&type=style&index=0&id=36eb4d7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb4d7e",
  null
  
)

/* custom blocks */
import block0 from "./ColumnChartGridWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports